import { PropertyCard } from "./PropertyCard";
import { Property } from "@/types/marketplace";
import { OptimizedImage } from "@/components/OptimizedImage";
import { cn } from "@/lib/utils";

interface PropertyGridProps {
  properties: Property[];
  className?: string;
  columns?: 3 | 4;
  hasActiveFilters?: boolean;
}

export const PropertyGrid = ({ properties, className, columns = 3, hasActiveFilters = false }: PropertyGridProps) => {

  if (properties.length === 0) {
    return (
      <div className="text-center py-16 animate-fade-in">
        <div className="max-w-md mx-auto">
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-zinc-100 flex items-center justify-center">
            {hasActiveFilters ? (
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-zinc-400"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            ) : (
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-zinc-400"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
            )}
          </div>
          <h3 className="text-xl font-semibold mb-2">
            {hasActiveFilters ? "Nenhum imóvel encontrado" : "Novos imóveis em breve"}
          </h3>
          <p className="text-muted-foreground mb-6">
            {hasActiveFilters 
              ? "Tente ajustar os filtros para encontrar mais opções."
              : "Estamos preparando os melhores imóveis para você. Volte em breve!"}
          </p>
        </div>
      </div>
    );
  }

  const gridClass = columns === 4 
    ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
    : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6";

  return (
    <div className={cn(gridClass, className)}>
      {properties.map((property, index) => (
        <div
          key={property.id}
          className={`animate-fade-in`}
          style={{ animationDelay: `${Math.min(index * 50, 200)}ms` }}
        >
          <PropertyCard property={property} priority={index < 3} />
        </div>
      ))}
    </div>
  );
};